import { updateObject, getFormattedFormState } from "../../shared/utility";
import {
  globalConstants,
  localStorageKeys,
  eventBookingConstants,
  EMPTY_STRING,
} from "../../constants";
import { getItemFromStorage, getLocalStorageItem } from "../../system";
// getting the default actions name from defined constants via decomposition
const {
  TOTAL_EVENTS,
  GET_SHOT_LIST,
  GET_AVAILABLE_SHUTTER_BS,
  GET_EVENT_TYPES,
  GET_EVENT_TYPE_SHOT_LIST,
  ADD_RECAPZ,
  IS_EDIT_EVENT,
  IS_DRAFT_EVENT,
  LAST_ACTIVE_TAB,
  SET_FORM_STATE,
  SET_EDIT_EVENTS,
  SET_DRAFT_EVENTS,
  ADD_RECAPZ_BACKUP,
  EVENT_ALREADY_EXIST,
  IS_SB_TIP_EXTEND_CART,
  USE_SAME_LOGO_FOR_ALL_RECAPS,
  SET_CART_TAB,
  SET_IS_PROFILE_VIEW,
  SELECTED_SHUTTER_BS,
  SELECTED_EVENT_ID,
  CURRENT_EVENT_TYPE,
  EVENT_NAME,
  CHECK_OUT,
  REQUEST_BOOKING,
  SET_REEL_VALUES,
  GET_REEL_PRICE,
  GET_MISC_AMOUNTS,
  GET_MISC_AMOUNTS_OLD,
  REEL_STORED,
  SET_UNDO_CART_ITEM,
  SET_IS_DRAFT_EVENT_ALLOWED,
  SET_BULK_REEL_VALUES,
  SET_EVENT_DETAIL_VALUES,
  EVENT_DETAIL_STORED,
  GET_REEL_TYPES,
  SET_BULK_EVENT_DETAIL_VALUES,
  SET_REEL_VALUES_ON_DELETE,
  GET_EDIT_BRIEF,
  GET_RECAP_TYPES,
  GET_AVAILABLE_SHUTTERB,
  REGENERATE_EDIT_BRIEF,
} = eventBookingConstants;

// getting reels from local storage if stored
const reelStored = JSON.parse(localStorage.getItem(REEL_STORED));
const eventDetailStored = JSON.parse(localStorage.getItem(EVENT_DETAIL_STORED));
const eventExist = getItemFromStorage(localStorageKeys.EVENT_ALREADY_EXIST);
const isShutterBTipExtend = getItemFromStorage(
  localStorageKeys.SHUTTERB_TIP_EXTEND_CART
);
const useSameLogoForAllRecaps = getItemFromStorage(localStorageKeys.USE_SAME_LOGO_FOR_ALL_RECAPS);

const editEvents = getLocalStorageItem(localStorageKeys.EDIT_EVENTS, null);
const totalEvents = getLocalStorageItem(localStorageKeys.TOTAL_EVENTS, 1);
const addRecapzValue = getLocalStorageItem(localStorageKeys.ADD_RECAPZ, []);
const draftEvents = getLocalStorageItem(localStorageKeys.DRAFT_EVENTS, null);
const isEditEvent = getLocalStorageItem(localStorageKeys.IS_EDIT_EVENT, null);
const isDraftEvent = getLocalStorageItem(localStorageKeys.IS_DRAFT_EVENT, null);
const addRecapzBackup = getLocalStorageItem(
  localStorageKeys.ADD_RECAPZ_BACKUP,
  []
);

// default state
const initialState = {
  eventTypes: [],
  currentEventType: null,
  addRecapz: addRecapzValue,
  shotList: [],
  reelTypes: [],
  recapTypes: [],
  shutterBCount: 0,
  formState: getFormattedFormState(),
  editEvents: editEvents,
  draftEvents: draftEvents,
  isEditEvent: isEditEvent,
  totalEvents: totalEvents,
  isDraftEvent: isDraftEvent,
  availableShutterBs: [],
  cartTab: false,
  url: null,
  eventRequested: "",
  transactionDone: false,
  showPage: false,
  addRecapzBackup: addRecapzBackup,
  eventAlreadyExist: eventExist === "true",
  isSBTipExtendCart: isShutterBTipExtend === "true",
  useSameLogoForAllRecaps: useSameLogoForAllRecaps === "true",
  selectedEventId: null,
  isProfileViewShow: false,
  eventName: EMPTY_STRING,
  previousActiveTab: EMPTY_STRING,
  regenerateEditBriefs: false,
  addReel: {
    isReelWithoutLogo: reelStored?.isReelWithoutLogo ?? false,
    reelPriceWithoutLogo: reelStored?.reelPriceWithoutLogo ?? 75,
    reelQtyWithoutLogo: reelStored?.reelQtyWithoutLogo ?? 0,
    isReelWithLogo: reelStored?.isReelWithLogo ?? true,
    reelPriceWithLogo: reelStored?.reelPriceWithLogo ?? 125,
    reelQtyWithLogo: reelStored?.reelQtyWithLogo ?? 0,
    logo: reelStored?.logo ?? {
      preview: "",
      raw: "",
    },
    musicFile: reelStored?.musicFile ?? {
      preview: "",
      filePath: null,
    },
    reelQuestion1: reelStored?.reelQuestion1 ?? "",
    music: reelStored?.music ?? "",
    orientation:
      reelStored?.orientation ??
      eventBookingConstants.REEL_ORIENTATION_OPTIONS[0],
    terms: reelStored?.terms ?? false,
    reelTotal: reelStored?.reelTotal ?? 0,
    isReelSubmitted: reelStored?.isReelSubmitted ?? false,
    reelType: reelStored?.reelType ?? "",
  },

  addEventDetail: {
    eventQuestion1: eventDetailStored?.eventQuestion1 ?? "",
    eventQuestion2: eventDetailStored?.eventQuestion2 ?? "",
    eventQuestion3: eventDetailStored?.eventQuestion3 ?? "",
    eventQuestion4: eventDetailStored?.eventQuestion4 ?? "",
  },
  miscAmounts: {},
  miscAmountsOld: {},
  undoCartItem: {},
  isDraftEventAllowed: false,
};

// manupilating the state based on actions and returning the state
export const eventBooking = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHOT_LIST:
      return updateObject(state, {
        shotList: action.data.items,
      });
    case GET_EVENT_TYPES + globalConstants.SUCCESS:
    case GET_EVENT_TYPE_SHOT_LIST + globalConstants.SUCCESS:
      return updateObject(state, {
        eventTypes: action.data,
      });
    case GET_AVAILABLE_SHUTTERB + globalConstants.SUCCESS:
    case GET_AVAILABLE_SHUTTER_BS + globalConstants.SUCCESS:
      const newArray = action.data.items.map((item) => {
        return {
          ...item,
        };
      });
      return updateObject(state, {
        availableShutterBs: newArray,
        shutterBCount: action.data.items.length,
      });
    case GET_AVAILABLE_SHUTTERB + globalConstants.FAILURE:
    case GET_AVAILABLE_SHUTTER_BS + globalConstants.FAILURE:
      return updateObject(state, {
        availableShutterBs: [],
        shutterBCount: 0,
      });
    case ADD_RECAPZ:
    case GET_EDIT_BRIEF + globalConstants.SUCCESS:
      return updateObject(state, {
        addRecapz: action.data,
      });
    case GET_RECAP_TYPES + globalConstants.SUCCESS:
      return updateObject(state, {
        recapTypes: action.data.items ?? [],
      });
    case ADD_RECAPZ_BACKUP:
      return updateObject(state, {
        addRecapzBackup: action.data ?? [],
      });
    case LAST_ACTIVE_TAB:
      return updateObject(state, {
        previousActiveTab: action.data,
      });
    case REGENERATE_EDIT_BRIEF:
      return updateObject(state, {
        regenerateEditBriefs: action.data,
      });
    case SET_FORM_STATE:
      return updateObject(state, { formState: action.data });
    case SET_EDIT_EVENTS:
      return updateObject(state, { editEvents: action.data });
    case SET_DRAFT_EVENTS:
      return updateObject(state, { draftEvents: action.data });
    case EVENT_ALREADY_EXIST:
      return updateObject(state, { eventAlreadyExist: action.data });
    case IS_SB_TIP_EXTEND_CART:
      return updateObject(state, { isSBTipExtendCart: action.data });
    case USE_SAME_LOGO_FOR_ALL_RECAPS:
      return updateObject(state, { useSameLogoForAllRecaps: action.data });
    case SET_CART_TAB:
      return updateObject(state, { cartTab: action.data });
    case TOTAL_EVENTS:
      return updateObject(state, { totalEvents: action.data });
    case SET_IS_PROFILE_VIEW:
      return updateObject(state, { isProfileViewShow: action.data });
    case SELECTED_SHUTTER_BS:
      return updateObject(state, { selectedShutterBz: action.data });
    case CHECK_OUT:
      return updateObject(state, { url: action.data.message, showPage: true });
    case REQUEST_BOOKING:
      return updateObject(state, { eventRequested: true });
    case SELECTED_EVENT_ID:
      return updateObject(state, { selectedEventId: action.data });
    case IS_EDIT_EVENT:
      return updateObject(state, { isEditEvent: action.data });
    case IS_DRAFT_EVENT:
      return updateObject(state, { isDraftEvent: action.data });
    case CURRENT_EVENT_TYPE:
      return updateObject(state, { currentEventType: action.data });
    case EVENT_NAME:
      return updateObject(state, { eventName: action.data });
    case REQUEST_BOOKING + globalConstants.FAILURE:
      return updateObject(state, { eventRequested: false });
    case GET_REEL_PRICE + globalConstants.SUCCESS:
      let updatedAddReelPrice = {
        addReel: {
          ...state.addReel,
          reelPriceWithoutLogo: action?.data?.items.priceOnPerReel,
          reelPriceWithLogo: action?.data?.items.priceOnPerReelWithLogo,
        },
      };
      localStorage.setItem(
        REEL_STORED,
        JSON.stringify(updatedAddReelPrice.addReel)
      );
      return updateObject(state, updatedAddReelPrice);
    case SET_REEL_VALUES:
      let updatedAddReel = {
        addReel: {
          ...state.addReel,
          [action.data.name]: action.data.value,
        },
      };
      localStorage.setItem(REEL_STORED, JSON.stringify(updatedAddReel.addReel));
      return updateObject(state, updatedAddReel);

    case SET_REEL_VALUES_ON_DELETE:
      let reel = {
        addReel: action.data.value,
      };
      localStorage.setItem(REEL_STORED, JSON.stringify(reel.addReel));
      return updateObject(state, reel);

    case SET_BULK_REEL_VALUES:
      let updatedBulkAddReel = {
        addReel: Object.keys(initialState.addReel).reduce(
          (accumulator, current) => {
            accumulator[current] = null;
            if (current === "orientation") {
              accumulator[current] =
                eventBookingConstants.REEL_ORIENTATION_OPTIONS[0];
            } else if (current === "logo") {
              accumulator[current] = {
                preview: "",
                raw: "",
              };
            }
            return accumulator;
          },
          {}
        ),
      };
      localStorage.setItem(
        REEL_STORED,
        JSON.stringify(updatedBulkAddReel.addReel)
      );
      return updateObject(state, updatedBulkAddReel);
    case GET_MISC_AMOUNTS:
      return updateObject(state, { miscAmounts: action?.data?.items });
    case GET_MISC_AMOUNTS_OLD:
      return updateObject(state, { miscAmountsOld: action?.data });
    case SET_UNDO_CART_ITEM:
      return updateObject(state, { undoCartItem: action?.data });
    case SET_IS_DRAFT_EVENT_ALLOWED:
      return updateObject(state, { isDraftEventAllowed: action?.data });
    case SET_EVENT_DETAIL_VALUES:
      let updatedEventDetail = {
        addEventDetail: {
          ...state.addEventDetail,
          [action.data.name]: action.data.value,
        },
      };
      localStorage.setItem(
        EVENT_DETAIL_STORED,
        JSON.stringify(updatedEventDetail.addEventDetail)
      );
      return updateObject(state, updatedEventDetail);
    case GET_REEL_TYPES:
      return updateObject(state, { reelTypes: action.data?.items });
    case SET_BULK_EVENT_DETAIL_VALUES:
      let updatedBulkEventDetail = {
        addEventDetail: Object.keys(initialState.addEventDetail).reduce(
          (accumulator, current) => {
            accumulator[current] = null;
            return accumulator;
          },
          {}
        ),
      };
      localStorage.setItem(
        EVENT_DETAIL_STORED,
        JSON.stringify(updatedBulkEventDetail.addEventDetail)
      );
      return updateObject(state, updatedBulkEventDetail);
    default:
      return state;
  }
};
